import { AxiosResponse } from 'axios';
import { useQuery, useMutation } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { CreateClassRequest, Class, ClassKey, UpdateClassRequest } from './class.types';

/**
 *
 * @param enabled boolean
 * @param status number - filters by statusNo
 * @returns Class[]
 */
export const useGetClasses = (
    status?: number,
    enabled: boolean = true
) => {
  return useQuery<AxiosResponse<Class[]>>({
    queryKey: ['getClasses', status],
    queryFn: () =>
        apiClient.get<Class[]>('/classes', { params: { status } }),
    enabled
  });
};

export const useCreateClass = () => {
  return useMutation({
    mutationKey: ['createClass'],
    mutationFn: (requestBody: CreateClassRequest) =>
        apiClient.post<Class>(`/classes`, requestBody)
  });
};

export const useGetClass = (
    {
      classId
    }: ClassKey
) => {
  return useQuery({
    queryKey: ['class', classId],
    queryFn: () =>
        apiClient.get<Class>(`/classes/${classId}`)
  });
};

export const useUpdateClass = (
    {
      classId
    }: ClassKey
) => {
  return useMutation({
    mutationKey: ['updateClass', classId],
    mutationFn: (requestBody: UpdateClassRequest) =>
        apiClient.put<Class>(`/classes/${classId}`, requestBody)
  });
};

export const useDeleteClass = (
    {
      classId
    }: ClassKey
) => {
  return useMutation({
    mutationKey: ['deleteClass', classId],
    mutationFn: () =>
        apiClient.delete(`/classes/${classId}`)
  });
}

export const useGetMenuItemRecipeClasses = (
    menuNo: string,
    requestBody: { strategyNo?: string },
    enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Class[]>>({
    queryKey: ['getMenuItemRecipeClasses', menuNo, requestBody.strategyNo],
    queryFn: () => apiClient.get<Class[]>(`/menus/${menuNo}/items/recipes/classes`, { params: requestBody }),
    enabled
  });
};

export const useGetMenuItemSubRecipeClasses = (
    menuNo: string,
    enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Class[]>>({
    queryKey: ['getMenuItemSubRecipeClasses', menuNo],
    queryFn: () => apiClient.get<Class[]>(`/menus/${menuNo}/items/sub-recipes/classes`),
    enabled
  });
};